// import React, { useState } from "react";
// import { 
//   FaUser, 
//   FaLock, 
//   FaBell, 
//   FaQuestionCircle, 
//   FaChevronRight, 
//   FaChevronDown,
//   FaSearch,
//   FaHeadset,
//   FaSave,
//   FaCamera
// } from "react-icons/fa";

// export default function HelpAndSettings() {
//   const [activeTab, setActiveTab] = useState("general");
//   const [openFaqIndex, setOpenFaqIndex] = useState(null);

//   const toggleFaq = (index) => {
//     setOpenFaqIndex(openFaqIndex === index ? null : index);
//   };

//   // Sidebar Navigation Items
//   const navItems = [
//     { id: "general", label: "General", icon: FaUser, desc: "Profile & Account" },
//     { id: "security", label: "Security", icon: FaLock, desc: "Password & 2FA" },
//     { id: "notifications", label: "Notifications", icon: FaBell, desc: "Email & SMS" },
//     { id: "help", label: "Help Center", icon: FaQuestionCircle, desc: "FAQ & Support" },
//   ];

//   // Mock FAQ Data
//   const faqs = [
//     { question: "How do I integrate a new employee?", answer: "Navigate to the Integration page, enter the employee's WhatsApp number, and click 'Save Settings'. The system will automatically send a verification message." },
//     { question: "Why are messages not being delivered?", answer: "Check if the 'Enable Notifications' toggle is active. Also ensure your business WhatsApp credits are topped up in the billing section." },
//     { question: "Can I customize the message template?", answer: "Yes! Go to the Integration page. You can use smart variables like {{name}} and {{date}} to personalize messages." },
//   ];

//   return (
//     <div className="min-h-screen bg-slate-50 font-sans text-slate-800 p-6 lg:p-12">
      
//       {/* HEADER */}
//       <div className="max-w-6xl mx-auto mb-8">
//         <h1 className="text-3xl font-bold text-slate-900">Settings & Support</h1>
//         <p className="mt-2 text-slate-500">Manage your account preferences and find answers.</p>
//       </div>

//       <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-8">
        
//         {/* LEFT SIDEBAR */}
//         <div className="lg:w-1/4">
//           <nav className="space-y-2">
//             {navItems.map((item) => (
//               <button
//                 key={item.id}
//                 onClick={() => setActiveTab(item.id)}
//                 className={`w-full flex items-center gap-4 p-4 rounded-xl text-left transition-all duration-200 group
//                   ${activeTab === item.id 
//                     ? "bg-white shadow-md border border-slate-100 ring-1 ring-slate-900/5" 
//                     : "hover:bg-white/60 hover:shadow-sm text-slate-500"
//                   }`}
//               >
//                 <div className={`p-3 rounded-lg transition-colors
//                   ${activeTab === item.id ? "bg-slate-900 text-white" : "bg-slate-200 text-slate-500 group-hover:text-slate-700"}`}>
//                   <item.icon className="text-lg" />
//                 </div>
//                 <div>
//                   <p className={`font-semibold ${activeTab === item.id ? "text-slate-900" : "text-slate-600"}`}>
//                     {item.label}
//                   </p>
//                   <p className="text-xs text-slate-400">{item.desc}</p>
//                 </div>
//               </button>
//             ))}
//           </nav>
//         </div>

//         {/* RIGHT CONTENT AREA */}
//         <div className="lg:w-3/4">
          
//           {/* --- GENERAL TAB --- */}
//           {activeTab === "general" && (
//             <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 animate-fadeIn">
//               <h2 className="text-xl font-bold text-slate-900 mb-6">General Settings</h2>
              
//               {/* Profile Photo */}
//               <div className="flex items-center gap-6 mb-8 pb-8 border-b border-slate-100">
//                 <div className="relative">
//                   <div className="w-24 h-24 rounded-full bg-slate-200 flex items-center justify-center text-3xl text-slate-400 overflow-hidden border-4 border-slate-50">
//                      <img src="https://i.pravatar.cc/150?img=68" alt="Profile" className="w-full h-full object-cover" />
//                   </div>
//                   <button className="absolute bottom-0 right-0 bg-slate-900 text-white p-2 rounded-full border-4 border-white shadow-lg hover:bg-slate-700 transition">
//                     <FaCamera className="text-xs" />
//                   </button>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-lg">Profile Photo</h3>
//                   <p className="text-sm text-slate-500">This will be displayed on your profile.</p>
//                 </div>
//               </div>

//               {/* Form */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="space-y-2">
//                   <label className="text-sm font-medium text-slate-700">First Name</label>
//                   <input type="text" defaultValue="Alex" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" />
//                 </div>
//                 <div className="space-y-2">
//                   <label className="text-sm font-medium text-slate-700">Last Name</label>
//                   <input type="text" defaultValue="Morgan" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" />
//                 </div>
//                 <div className="space-y-2 md:col-span-2">
//                   <label className="text-sm font-medium text-slate-700">Email Address</label>
//                   <input type="email" defaultValue="alex.morgan@company.com" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" />
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end">
//                 <button className="bg-slate-900 text-white px-6 py-3 rounded-xl font-semibold shadow-lg shadow-slate-900/20 flex items-center gap-2 hover:bg-slate-800 transition active:scale-95">
//                   <FaSave /> Save Changes
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* --- SECURITY TAB --- */}
//           {activeTab === "security" && (
//             <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 animate-fadeIn">
//               <h2 className="text-xl font-bold text-slate-900 mb-6">Security Settings</h2>
              
//               <div className="space-y-6">
//                 <div className="space-y-2">
//                   <label className="text-sm font-medium text-slate-700">Current Password</label>
//                   <input type="password" placeholder="••••••••" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 outline-none" />
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div className="space-y-2">
//                     <label className="text-sm font-medium text-slate-700">New Password</label>
//                     <input type="password" placeholder="••••••••" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 outline-none" />
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-sm font-medium text-slate-700">Confirm Password</label>
//                     <input type="password" placeholder="••••••••" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-green-500 outline-none" />
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-8 pt-8 border-t border-slate-100 flex items-center justify-between">
//                  <div>
//                     <h3 className="font-semibold text-slate-900">Two-Factor Authentication</h3>
//                     <p className="text-sm text-slate-500">Add an extra layer of security to your account.</p>
//                  </div>
//                  <button className="bg-green-100 text-green-700 px-4 py-2 rounded-lg text-sm font-semibold border border-green-200 hover:bg-green-200 transition">
//                     Enable 2FA
//                  </button>
//               </div>
//             </div>
//           )}

//            {/* --- NOTIFICATIONS TAB --- */}
//            {activeTab === "notifications" && (
//             <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 animate-fadeIn">
//               <h2 className="text-xl font-bold text-slate-900 mb-6">Notification Preferences</h2>
              
//               <div className="space-y-6">
//                  {['Email Alerts', 'Push Notifications', 'Weekly Reports', 'System Maintenance'].map((item, idx) => (
//                     <div key={idx} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100">
//                        <div>
//                           <h4 className="font-semibold text-slate-800">{item}</h4>
//                           <p className="text-sm text-slate-500">Receive updates about {item.toLowerCase()}.</p>
//                        </div>
//                        <div className="relative inline-block w-12 h-6 align-middle select-none transition duration-200 ease-in">
//                           <input type="checkbox" defaultChecked={idx < 2} name="toggle" id={`toggle-${idx}`} className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer checked:right-0 right-6 checked:border-green-500 border-slate-300"/>
//                           <label htmlFor={`toggle-${idx}`} className="toggle-label block overflow-hidden h-6 rounded-full bg-slate-300 cursor-pointer checked:bg-green-500"></label>
//                        </div>
//                     </div>
//                  ))}
//               </div>
//             </div>
//           )}

//           {/* --- HELP TAB --- */}
//           {activeTab === "help" && (
//             <div className="space-y-6 animate-fadeIn">
              
//               {/* Search Bar */}
//               <div className="bg-slate-900 text-white p-8 rounded-2xl shadow-lg relative overflow-hidden">
//                 <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl transform translate-x-10 -translate-y-10"></div>
//                 <h2 className="text-2xl font-bold mb-2">How can we help you?</h2>
//                 <div className="relative mt-4">
//                    <FaSearch className="absolute left-4 top-3.5 text-slate-400" />
//                    <input 
//                       type="text" 
//                       placeholder="Search for answers..." 
//                       className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-slate-300 focus:bg-white focus:text-slate-900 focus:placeholder-slate-500 transition-all outline-none"
//                    />
//                 </div>
//               </div>

//               {/* FAQ Accordion */}
//               <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
//                 <h3 className="text-lg font-bold text-slate-900 mb-4">Frequently Asked Questions</h3>
//                 <div className="space-y-3">
//                   {faqs.map((faq, index) => (
//                     <div key={index} className="border border-slate-100 rounded-xl overflow-hidden">
//                       <button 
//                         onClick={() => toggleFaq(index)}
//                         className="w-full flex items-center justify-between p-4 bg-slate-50 hover:bg-slate-100 transition text-left"
//                       >
//                         <span className="font-semibold text-slate-700">{faq.question}</span>
//                         <FaChevronDown className={`text-slate-400 transition-transform duration-300 ${openFaqIndex === index ? "rotate-180" : ""}`} />
//                       </button>
//                       <div 
//                         className={`transition-all duration-300 ease-in-out overflow-hidden ${openFaqIndex === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"}`}
//                       >
//                         <p className="p-4 text-slate-500 text-sm leading-relaxed border-t border-slate-100">
//                           {faq.answer}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Contact Support Card */}
//               <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl border border-green-100 p-6 flex items-center justify-between">
//                  <div className="flex items-center gap-4">
//                     <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-green-600 shadow-sm">
//                        <FaHeadset />
//                     </div>
//                     <div>
//                        <h3 className="font-bold text-green-900">Still need help?</h3>
//                        <p className="text-sm text-green-700">Our support team is available 24/7.</p>
//                     </div>
//                  </div>
//                  <button className="bg-green-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-green-700 shadow-lg shadow-green-600/20 transition">
//                     Contact Support
//                  </button>
//               </div>

//             </div>
//           )}

//         </div>
//       </div>
      
//       {/* Simple CSS for toggle switch since tailwind default form plugin might not be installed */}
//       <style>{`
//         .toggle-checkbox:checked {
//           right: 0;
//           border-color: #22c55e;
//         }
//         .toggle-checkbox:checked + .toggle-label {
//           background-color: #22c55e;
//         }
//       `}</style>
//     </div>
//   );
// }

export default function HelpAndSettings() {
    return(
        <>
        <h1>help</h1></>
    )
}